import { render, staticRenderFns } from "./ueditor.vue?vue&type=template&id=0fc7c02b&"
import script from "./ueditor.vue?vue&type=script&lang=js&"
export * from "./ueditor.vue?vue&type=script&lang=js&"
import style0 from "./ueditor.vue?vue&type=style&index=0&id=0fc7c02b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports